import bootbox from 'bootbox';

$(document).ready(function(e){
    let $mobile_nav = $('.mobile-nav-container');

    if($mobile_nav.length){
        let $icons = $('.mobile-nav-container > .icon:not(.more-icon)'),
            $more_dropdown = $('.more-dropdown');

        if($icons.length > 4){
            $icons = $icons.slice(4, $icons.length);

            $icons.each(function(index, $icon){
                let $icon_link = $($icon).find('a'),
                    text = $icon_link.attr('data-tooltip');
                $icon_link.find('span.text').append(text);
                $icon_link.find('.far').remove();
                $icon_link.detach().appendTo($more_dropdown).addClass('dropdown-item');
                $icon.remove();
            })
        }

        $mobile_nav.removeClass('d-none');

        let $dropdown_items = $mobile_nav.find('.more-dropdown').find('.dropdown-item');

        if(!$dropdown_items.length){
            $more_dropdown.parents('.icon.more-icon').remove();
        }
    }
});